<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <b-card no-body>
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <b-media
                  no-body
                  vertical-align="center"
                  class="d-flex align-items-center"
                >
                  <b-media-body>
                    <b-form-file
                      id="image"
                      accept=".jpg, .png, .gif"
                      @change="loadImage($event)"
                      placeholder="Select Image"
                      drop-placeholder="Drop file here..."
                    />
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th class="text-center">Image</th>
                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(paymentMethod, index) in paymentMethods.data"
                  :key="index"
                  v-if="paymentMethods.data.length"
                >
                  <td class="align-middle">
                    {{ index + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    <img
                      :src="$store.state.base_url + paymentMethod.image"
                      alt=""
                      width="140"
                      height="70"
                    />
                  </td>
                  <td class="align-middle text-right">
                    <button
                      class="btn btn-danger btn-sm"
                      @click="destroy(paymentMethod.id)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
      <div class="col-md-4">
        <b-card title="Description">
          <b-card-text
            ><validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
                enctype="multipart/form-data"
              >
                <div class="row">
                  <div class="col-md-12">
                    <b-media no-body vertical-align="center">
                      <b-media-aside>
                        <b-img
                          :src="video_thumbnail"
                          height="174"
                          width="210"
                          class="rounded mr-2 mb-1 mb-md-0"
                        />
                      </b-media-aside>
                      <b-media-body>
                        <b-form-group
                          label="Video Thumbnail"
                          label-for="video_thumbnail"
                        >
                          <b-form-file
                            id="video_thumbnail"
                            accept=".jpg, .png, .gif"
                            @change="loadVideoThumnailImage($event)"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                          />
                        </b-form-group>
                        <b-form-group label="Video ID" label-for="video_id">
                          <validation-provider
                            #default="{ errors }"
                            name="video_id"
                          >
                            <b-form-input
                              id="video_id"
                              v-model="form.video_id"
                              :state="errors.length > 0 ? false : null"
                              name="video_id"
                              placeholder="Enter Your Video ID"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-media-body>
                    </b-media>
                    <b-form-group label=" Title" label-for="title">
                      <b-form-input
                        id="title"
                        v-model="form.title"
                        name="title"
                        placeholder="Enter Title"
                      />
                    </b-form-group>
                    <b-form-group label-for="description">
                      <validation-provider
                        #default="{ errors }"
                        name="description"
                        rules="required"
                      >
                        <b-form-textarea
                          id="description"
                          v-model="form.description"
                          :state="errors.length > 0 ? false : null"
                          name="description"
                          placeholder="Enter Your Description"
                          rows="6"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                </div>
                <!-- submit buttons -->
                <b-button
                  type="submit"
                  class="float-right"
                  variant="primary"
                  @click="validationForm"
                >
                  Update
                </b-button>
              </b-form>
            </validation-observer>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      paymentMethods: [],
      image: "",
      id: "",
      video_thumbnail: this.$store.state.base_url + "assets/images/placeholder/1280X720.svg",
      form: {
        id: "",
        description: "",
        title: "",
        video_id: "",
        video_thumbnail: "",
      },
    };
  },
  mounted() {
    this.getResults();
    this.load();
  },
  methods: {
    async getResults() {
      const paymentMethods = await this.callApi("get", "/payment-method");
      if (paymentMethods.status == 200) {
        this.paymentMethods = paymentMethods?.data;
      }
    },

    loadImage(e) {
      this.image = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.add();
      };
      reader.readAsDataURL(file);
    },

    loadVideoThumnailImage(e) {
      this.form.video_thumbnail = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.video_thumbnail = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async load() {
      const paymentMethods = await this.callApi(
        "get",
        "/payment-method/description"
      );
      if (paymentMethods.status == 200) {        
        this.form.description = paymentMethods.data.data.description;
        this.form.title = paymentMethods.data.data.title;
        this.form.video_id = paymentMethods.data.data.video_id;
        this.form.video_thumbnail = null;
        this.video_thumbnail = this.$store.state.base_url+paymentMethods.data.data.video_thumbnail;
      }
    },

    async edit() {
      const fd = new FormData();
      if (this.form.video_thumbnail) {
        fd.append("video_thumbnail", this.form.video_thumbnail);
      }
      fd.append("title", this.form.title);
      fd.append("video_id", this.form.video_id);
      fd.append("description", this.form.description);
      axios
        .post("/payment-method/description", fd)
        .then((res) => {
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.description)
              this.e(e.response.data.errors.description[0]);
          }
        });
    },

    add() {
      const fd = new FormData();
      if (this.image) {
        fd.append("image", this.image);
      }
      axios
        .post("/payment-method", fd)
        .then((res) => {
          this.image = "";
          this.getResults();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.image)
              this.e(e.response.data.errors.image[0]);
          }
        });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.edit(this.id);
        }
      });
    },

    async destroy(id) {
      const paymentMethods = await this.callApi(
        "delete",
        "/payment-method/" + id
      );
      if (paymentMethods.status == 200) {
        this.getResults();
        this.s(paymentMethods.data.message);
      }
    },
  },

  components: {
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
};
</script>

<style></style>
